import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await register(f.email, f.password, f.name);
      toast.success(`Account ready, ${u.name}. Welcome!`);
      nav("/dashboard");
    } catch (err) {
      toast.error(errMsg(err, "Signup failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="signup-page">
      <div className="hidden md:block relative">
        <img src="https://images.pexels.com/photos/6985132/pexels-photo-6985132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          className="absolute inset-0 w-full h-full object-cover opacity-80" alt=""/>
        <div className="absolute inset-0 bg-gradient-to-tr from-[#05050A] via-black/70 to-transparent"/>
        <div className="absolute bottom-10 left-10 max-w-md">
          <span className="label-mono">Craftora Studio</span>
          <div className="font-display font-black text-4xl mt-3 leading-tight">Create your workspace to brief, chat and receive your build.</div>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <Link to="/" className="label-mono">← Home</Link>
          <h1 className="font-display font-black text-4xl mt-4">Create account</h1>
          <input required placeholder="Full name" value={f.name} onChange={e=>setF({...f,name:e.target.value})}
            data-testid="signup-name"
            className="w-full mt-8 bg-transparent hairline-strong rounded-lg px-4 py-3 outline-none focus:border-violet-500"/>
          <input type="email" required placeholder="Email" value={f.email} onChange={e=>setF({...f,email:e.target.value})}
            data-testid="signup-email"
            className="w-full mt-3 bg-transparent hairline-strong rounded-lg px-4 py-3 outline-none focus:border-violet-500"/>
          <input type="password" required placeholder="Password (min 8 chars)" minLength={8} autoComplete="new-password"
            value={f.password} onChange={e=>setF({...f,password:e.target.value})}
            data-testid="signup-password"
            className="w-full mt-3 bg-transparent hairline-strong rounded-lg px-4 py-3 outline-none focus:border-violet-500"/>
          <button disabled={busy} type="submit" className="pill-btn primary w-full justify-center mt-6" data-testid="signup-submit">
            {busy ? "Creating…" : "Create account"}
          </button>
          <div className="mt-8 text-sm text-white/60">
            Have an account? <Link to="/login" className="text-white link-underline">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
